import {
  clickEvent,
  trackClick,
  trackFacebookEvent,
  trackGoogleAdsConversion,
  trackGoogleEvent,
} from './core';

/**
 * Setup button elements with a named 'Click' event to be tracked on button click.
 *
 * @param element the button.
 */
export const setup = (element) => {
  if (element.dataset.analyticsEvent
    || element.dataset.fbEvent
    || element.dataset.ga4Event
    || (element.dataset.gAdsId && element.dataset.gAdsLabel)) {

    element.addEventListener('click', (e) => {
      if (element.dataset.analyticsEvent) {
        trackClick(element.dataset.analyticsEvent);
      }

      if (element.dataset.fbEvent) {
        trackFacebookEvent(element.dataset.fbEvent, clickEvent);
      }

      if (element.dataset.ga4Event) {
        trackGoogleEvent(element.dataset.fbEvent, clickEvent);
      }

      if (element.dataset.gAdsId && element.dataset.gAdsLabel) {
        trackGoogleAdsConversion(element.dataset.gAdsId,
          element.dataset.gAdsLabel);
      }
    });
  }
};